import { useReducer } from "react";
import { GlobalContext } from "./GlobalContext";

const win = window;
let lang;

if (window.location.href.includes("localhost")) {
  lang = "en";
  !!!win['base_portal_url'] && (win['base_portal_url'] = 'http://ssta004:8080')
} else {
  lang = document.documentElement.lang;
  win['base_portal_url'] = window.location.origin;
}

!!!win['payment_url'] && (win['payment_url'] = '/wps/portal/web/direct-payment');
!!!win['ftth_track_order_url'] && (win['ftth_track_order_url'] = '/wps/portal/web/personal/home-services/ftth-setup-track-status');

const rtl = lang === "ar";
!!!win["lang"] && (win["lang"] = lang);
document.documentElement.lang = lang;
document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
const dir = lang === null || lang === "en" ? "ltr" : "rtl";
const initialState = {
  rtl,
  dir,
  lang,
  loading: false,
  msisdn: '',
  nationalId: '',
  refId: '',
  smsSentTo: '',
  page: 'TR_Login',
  popup: '',
  orderRequestData: {},
  requestLists: [],
  requestDetails: {},
  orderInquiryErrRes: {},
  cancellationFormData: {},
  successType: ''
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_LOADER":
      return {
        ...state,
        loading: action.payload,
      };
    case "SET_MSISDN":
      return {
        ...state,
        msisdn: action.payload.msisdn,
        refId: action.payload.refId,
        smsSentTo: action.payload.smsSentTo,
        nationalId: action.payload.nationalId
      };
    case "UPDATE_PAGE":
      return {
        ...state,
        page: action.payload,
        popup: ''
      };
    case "UPDATE_POPUP":
      return {
        ...state,
        popup: action.payload,
      };
    case "UPDATE_ORDER_REQUEST_DATA":
      return {
        ...state,
        orderRequestData: action.payload,
      };
    case "RESET_DATA":
      return {
        ...initialState,
      }
    case "UPADTE_REQUEST_LISTS":
      return {
        ...state,
        requestLists: action.payload
      }
    case "ORDER_INQUIRY_ERROR_RESPONSE":
      return {
        ...state,
        orderInquiryErrRes: action.payload
      }
    case "UPDATE_REQUEST_DETAILS":
      return {
        ...state,
        requestDetails: action.payload
      }
    case "UPDATE_CANCELLATION_FORM_DATA":
      return {
        ...state,
        cancellationFormData: action.payload
      }
    case "UPDATE_SUCCESS_TYPE":
      return {
        ...state,
        successType: action.payload
      }
    default:
      return state;
  }
};

export const GlobalProvider = (props) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <GlobalContext.Provider value={{ state, dispatch }}>
      {props.children}
    </GlobalContext.Provider>
  );
};
